import React from 'react'
import { Parallax } from 'react-parallax'
import SanferRedLabel from '../../../baseComponents/SanferRedLabel'
import PageTitle from '../../../baseComponents/PageTitle'
import { getURLByRouteName } from '../../../utils/routes'

import titleLogo from '../../../assets/images/title-icons/Users-Line.svg'
import arrow from '../../../assets/images/svg_icons/arrow.svg'
import { Link } from 'react-router-dom'

const AboutSanfer = props => {
  const { texts } = props

  const { about } = props.data
    , items = about.items instanceof Array
      ? about.items
      : []

  return <Parallax renderLayer={percent => {
    let opacity = percent

    percent = Math.floor(percent * 100) + 15

    return <div className='home__about'>
      <div className='gray-line-vertical' />
      <div className='home__about-banner left' style={{ background: `url(${about.banner})`, }} />
      <div className='home__about-container' style={{ opacity }}>
        <SanferRedLabel />
        <PageTitle title={about.title} label={about.redLabel} logo={titleLogo} />

        <div className='home__about-block'>
          <div className='flex-row'>
            <div className='gray-line opacity-0' />
            <img src={titleLogo} className='opacity-0' alt='logo' />
          </div>
          <div className='home__about-block-content'>
            <p className='home__about-text gray-color justify'>{about.paragraphs}</p>
            <Link to={getURLByRouteName('aboutUs')} className='home__about-subtitle red-color'>{about.subtitle}</Link>
          </div>
        </div>

        <div className='home__about-block-container'>
          {
            items.map((item, index) => <div key={index}>
              <div className='home__about-block centered' >
                <div className='flex-row'>
                  <img src={titleLogo} className='opacity-0' alt='logo' style={{ marginLeft: '-1vmin' }} />
                  <div className='gray-line' />
                  <span className='gray-color-2'>+</span>
                </div>
                <p className='home__about-text bold'>{item.title}</p>
              </div>
              <div className='home__about-block centered' >
                <div className='flex-row opacity-0'>
                  <img src={titleLogo} className='opacity-0' alt='logo' style={{ marginLeft: '-1vmin' }} />
                  <div className='gray-line' />
                  <span className='gray-color-2'>+</span>
                </div>
                <div className='home__about-block centered' >
                  <div className='gray-line' />
                  <Link to={item.link} className='home__about-block centered'>
                    <span>{texts.readMore}</span>
                    <img className='arrow-left' src={arrow} alt='flecha' />
                  </Link>
                </div>
              </div>
            </div>)
          }
        </div>

      </div>
      <div className='home__about-banner right' style={{ background: `url(${about.banner})`, }} />
      <div className='gray-line' />
      <span className='gray-color-2'>+</span>
    </div>
  }}>
  </Parallax>
}

export default AboutSanfer
